import { clsx } from 'clsx';
import { Button } from '@components/common/Forms/Button/Button';
import { ButtonProps } from 'src/types/anchors-buttons';

/**
 * @description Pill-shaped "see all / show more" control rendered under previewed lists
 * (interview videos, mini interview Q&A, experiences, studies). Centers itself under the list.
 * It's a real button (keyboard/screen-reader friendly) styled like the legacy presentational pills.
 *
 * * **children** - the label, e.g. `` `${t('global.label.see.all.interviews')} +${hiddenCount}` ``
 * * **isLoading** / **className** / any other Button prop is passed through.
 */
export const ShowMorePill = ({ className, children, ...restProps }: ButtonProps) => (
  <Button
    styling="none"
    className={clsx(
      'mx-auto mt-5 flex w-fit cursor-pointer items-center gap-2 rounded-full bg-surface-100 px-4 py-2 text-center font-bold disabled:cursor-not-allowed disabled:opacity-60',
      className,
    )}
    {...restProps}
  >
    {children}
  </Button>
);
